export default __webpack_public_path__ + "static/cover-10-89e06ab755e6c427a36a23f85a3888b7.jpg";